exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox{margin:0 0 0 20px}.checkbox input{cursor:pointer;left:0;top:-2px}.checkbox label:after{padding-top:1px!important;color:#2f23d6!important}.checkbox label:before{outline:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ab97910","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/restricted/requestAdjustment/requestAdjustment.vue
// module id = 1000
// module chunks = 0